import React from 'react'
import Navbars from '../Navbars'
import Sidebar from '../profile/Sidebar'
import search from "../assets/search.png"
import Schduletab from './Schduletab'
import "./schedule.css"
import { IoMdArrowDropdown } from "react-icons/io"
import { MdOutlineKeyboardArrowLeft } from "react-icons/md"
import { MdOutlineKeyboardArrowRight } from "react-icons/md"
import group from "../assets/Group.png"

import Schedulemodal from './Schedulemodal.js'


function Schedule() {
    return (<>
        <div className='conatiner-fluid' style={{ backgroundColor: "#F5F5F5", position: "relative", height: "130vh" }}>
            <Navbars show="none" />
            <div className='d-flex gap-2 pe-3 main_div w-100'>
                <Sidebar />
                <div className='table_outer '>

                    <div className='inner_schedule_div mb-5'>
                        <div className='row ps-4   search_row pt-4'>
                            <div className='col-lg-10 col-md-12 col-sm-12'>
                                <div style={{ position: "relative" }}>
                                    <input placeholder='Search Business id, Business name, Zip code etc ' className='add_search business_search upper_input' />
                                    <img src={search} className="search_img" style={{ top: "14px", left: "14px" }} />
                                </div>
                            </div>
                            <div className='col-lg-2 col-md-4 col-sm-4  schudle_grid'>
                               <Schedulemodal/>
                            </div>


                        </div>
                        <div className='d-flex gap-3 flex-wrap align-items-center justify-content-between pe-4 ps-4  mt-3 mb-3 btndiv_schedule'>
                            <div className='d-flex gap-2 align-items-center flex-wrap'>
                                <button className='fill_btn'>Auto Fill</button>
                                <button className='platform_btn'>
                                    <div className='d-flex gap-2 align-items-center'>
                                        <p className='platform_text'>All Platforms</p>
                                        <IoMdArrowDropdown />
                                    </div>
                                </button>
                            </div>
                            <div className='d-flex gap-2 align-items-center schdule_div2'>
                                <div className='arrow_schedule_div'>
                                    <MdOutlineKeyboardArrowLeft style={{ fontSize: "50px" }} />
                                    <MdOutlineKeyboardArrowRight style={{ fontSize: "50px" }} />
                                </div>
                                <p className='schedule_date_text'>Dec 5 - Dec 10</p>
                                <img src={group} style={{height:"20px",width:"20px"}} />
                                <button className='platform_btn' style={{width:"100px"}}>
                                    <div className='d-flex gap-2 align-items-center'>
                                        <p className='platform_text' >Weekly</p>
                                        <IoMdArrowDropdown />
                                    </div>
                                </button>
                            </div>
                        </div>
                        <Schduletab />
                    </div>
                </div>
            </div>
        </div>
    </>
    )
}

export default Schedule